export default __webpack_public_path__ + "c9c92f4091dd9053cdad723220c10d15.jpeg";